/** 4.5 stars — 131×23 */
export const HeroStars = () => (
    <svg
        className="h-[23px] w-[131px] shrink-0"
        viewBox="0 0 131 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M11.5 0L14.0819 7.9463H22.4371L15.6776 12.8574L18.2595 20.8037L11.5 15.8926L4.74047 20.8037L7.32238 12.8574L0.56285 7.9463H8.91809L11.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M38.5 0L41.0819 7.9463H49.4371L42.6776 12.8574L45.2595 20.8037L38.5 15.8926L31.7405 20.8037L34.3224 12.8574L27.5628 7.9463H35.9181L38.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M65.5 0L68.0819 7.9463H76.4371L69.6776 12.8574L72.2595 20.8037L65.5 15.8926L58.7405 20.8037L61.3224 12.8574L54.5628 7.9463H62.9181L65.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M92.5 0L95.0819 7.9463H103.437L96.6776 12.8574L99.2595 20.8037L92.5 15.8926L85.7405 20.8037L88.3224 12.8574L81.5628 7.9463H89.9181L92.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M119.5 0L122.082 7.9463H130.437L123.678 12.8574L126.26 20.8037L119.5 15.8926L112.74 20.8037L115.322 12.8574L108.563 7.9463H116.918L119.5 0Z"
            fill="white"
        />
        <path d="M119.5 16V0L117 8H108.5L115.5 13L112.5 21L119.5 16Z" fill="#FFF27D" />
    </svg>
);

/** shield-check — 20×20 (no overflow clip so stroke isn’t cut) */
export const ShieldCheckIcon = ({ stroke = "white" }: { stroke?: string }) => (
    <svg
        className="size-5 shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M7.16667 10.1667L8.83333 11.8333L12.1667 8.5M16.3333 11C16.3333 15.1667 13.4167 17.25 9.95 18.4583C9.76847 18.5199 9.57128 18.5169 9.39167 18.45C5.91667 17.25 3 15.1667 3 11V5.16667C3 4.94565 3.0878 4.73369 3.24408 4.57741C3.40036 4.42113 3.61232 4.33333 3.83333 4.33333C5.5 4.33333 7.58333 3.33333 9.03333 2.06667C9.20988 1.91583 9.43446 1.83333 9.66667 1.83333C9.89887 1.83333 10.1235 1.91583 10.3 2.06667C11.7583 3.34167 13.8333 4.33333 15.5 4.33333C15.721 4.33333 15.933 4.42113 16.0893 4.57741C16.2455 4.73369 16.3333 4.94565 16.3333 5.16667V11Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** chart-line — 20×20 (no overflow clip so stroke isn’t cut) */
export const ChartLineIcon = ({ stroke = "white" }: { stroke?: string }) => (
    <svg
        className="size-5 shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M2.5 2.5V15.8333C2.5 16.2754 2.6756 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5M15.8333 7.5L11.6667 11.6667L8.33333 8.33333L5.83333 10.8333"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** banknote — outer 13.44×13.44 (desktop) / 12×12 (mobile), leaf inset 25% / 8.33% */
export const BanknoteIcon = ({ className = "size-[13.44px]" }: { className?: string }) => (
    <span className={`relative inline-block shrink-0 overflow-hidden ${className}`} aria-hidden>
        <span className="absolute bottom-1/4 left-[8.33%] right-[8.33%] top-1/4">
            <span className="absolute inset-[-6.25%_-3.75%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 12.038 7.55874"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.65956 3.77937H2.66516M9.37844 3.77937H9.38404M1.53974 0.41993H10.4983C11.1167 0.41993 11.6181 0.921288 11.6181 1.53974V6.019C11.6181 6.63745 11.1167 7.13881 10.4983 7.13881H1.53974C0.921288 7.13881 0.41993 6.63745 0.41993 6.019V1.53974C0.41993 0.921288 0.921288 0.41993 1.53974 0.41993ZM7.13881 3.77937C7.13881 4.39783 6.63745 4.89918 6.019 4.89918C5.40054 4.89918 4.89918 4.39783 4.89918 3.77937C4.89918 3.16091 5.40054 2.65956 6.019 2.65956C6.63745 2.65956 7.13881 3.16091 7.13881 3.77937Z"
                        stroke="#F15D2A"
                        strokeWidth="0.83986"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** Desktop wave — 1957×1970, evenodd so only arches show */
export const HeroWaveWeb = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="907"
        viewBox="0 0 1440 907"
        fill="none"
        className={className}
    >
        <path
            opacity="0.04"
            d="M1701 -597H-256V1373H1701V-597ZM1467.38 -361.823V-185.304C1022.91 -104.691 654.843 197.226 479.923 603.132C359.042 434.915 182.602 309.735 -22.3753 254.901V-361.823H1467.38ZM-22.3753 553.214C207.56 646.388 370.001 872.936 370.001 1137.82H-22.3753V553.214ZM651.479 1137.82C651.479 634.264 999.909 212.737 1467.38 103.942V1137.82H651.479Z"
            fill="white"
        />
    </svg>
);

/** Mobile wave — dark navy bg, white @ 0.04 */
export const HeroWaveMobile = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="393"
        height="828"
        viewBox="0 0 393 828"
        fill="none"
        className={className}
    >
        <path
            opacity="0.04"
            d="M801 -127H-242V953H801V-127ZM676.488 1.92931V98.7011C439.608 142.895 243.442 308.413 150.217 530.941C85.7917 438.72 -8.24309 370.093 -117.488 340.032V1.92931H676.488ZM-117.488 503.574C5.05829 554.655 91.6328 678.853 91.6328 824.071H-117.488V503.574ZM241.649 824.071C241.649 548.008 427.348 316.917 676.488 257.273V824.071H241.649Z"
            fill="white"
        />
    </svg>
);

/** Mobile wave light bg — Figma 2541:36003, #E6E6E6 @ 0.51 */
export const HeroWaveMobileLight = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1043"
        height="1080"
        viewBox="0 0 1043 1080"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            opacity="0.51"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1043 0H0V1080H1043V0ZM918.488 128.929V225.701C681.608 269.895 485.442 435.413 392.217 657.941C327.792 565.72 233.757 497.093 124.512 467.032V128.929H918.488ZM124.512 630.574C247.058 681.655 333.633 805.853 333.633 951.071H124.512V630.574ZM483.649 951.071C483.649 675.008 669.348 443.917 918.488 384.273V951.071H483.649Z"
            fill="#E6E6E6"
        />
    </svg>
);

/** Ellipse 8 — outer 463×463, leaf inset -107.99% (1463 blur) */
export const HeroGlowOrange = ({ filterId }: { filterId: string }) => (
    <span className="pointer-events-none absolute inset-[-107.99%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 1463 1463"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.86" filter={`url(#${filterId})`}>
                <circle cx="731.5" cy="731.5" r="231.5" fill="#F47843" />
            </g>
            <defs>
                <filter
                    id={filterId}
                    x="0"
                    y="0"
                    width="1463"
                    height="1463"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="250" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);

/** Ellipse 9 desktop — outer 463×463, leaf inset -86.39% (1263 blur) */
export const HeroGlowBlueWeb = () => (
    <span className="pointer-events-none absolute inset-[-86.39%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 1263 1263"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#hero-glow-blue-web)">
                <circle cx="631.5" cy="631.5" r="231.5" fill="#375ED9" />
            </g>
            <defs>
                <filter
                    id="hero-glow-blue-web"
                    x="0"
                    y="0"
                    width="1263"
                    height="1263"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="200" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);

/** Ellipse 9 mobile — outer 329×329, leaf inset -60.79% (729 blur) */
export const HeroGlowBlueMobile = () => (
    <span className="pointer-events-none absolute inset-[-60.79%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 729 729"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#hero-glow-blue-mobile)">
                <circle cx="364.5" cy="364.5" r="164.5" fill="#375ED9" />
            </g>
            <defs>
                <filter
                    id="hero-glow-blue-mobile"
                    x="0"
                    y="0"
                    width="729"
                    height="729"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);
